export default {
  // dropdown menu data
  timezoneOptions: [
    {
      value: "-12",
      text: "(GMT -12:00) Eniwetok, Kwajalein",
      code: "ENIWETOK"
    },
    {
      value: "-11",
      text: "(GMT -11:00) Midway Island, Samoa",
      code: "MIDWAY"
    },
    {
      value: "-10",
      text: "(GMT -10:00) Hawaii",
      code: "HAWAII"
    },
    {
      value: "-9",
      text: "(GMT -9:00) Alaska",
      code: "ALASKA"
    },
    {
      value: "-8",
      text: "(GMT -8:00) Pacific Time (US & Canada)",
      code: "PACIFIC"
    },
    {
      value: "-7",
      text: "(GMT -7:00) Mountain Time (US & Canada)",
      code: "MOUNTAIN"
    },
    {
      value: "-6",
      text: "(GMT -6:00) Central Time (US & Canada), Mexico City",
      code: "CENTRAL"
    },
    {
      value: "-5",
      text: "(GMT -5:00) Eastern Time (US & Canada), Bogota, Lima",
      code: "EASTERN"
    },
    {
      value: "-4",
      text: "(GMT -4:00) Atlantic Time (Canada), Caracas, La Paz",
      code: "ATLANTIC"
    },
    {
      value: "-3.5",
      text: "(GMT -3:30) Newfoundland",
      code: "NEWFOUNDLAND"
    },
    {
      value: "-3",
      text: "(GMT -3:00) Brazil, Buenos Aires, Georgetown",
      code: "BRAZIL"
    },
    {
      value: "-2",
      text: "(GMT -2:00) Mid-Atlantic",
      code: "MID_ATLANTIC"
    },
    {
      value: "-1",
      text: "(GMT -1:00) Azores, Cape Verde Islands",
      code: "AZORES"
    },
    {
      value: "0",
      text: "(GMT) Western Europe Time, London, Lisbon, Casablanca",
      code: "WESTERN_EUR"
    },
    {
      value: "1",
      text: "(GMT +1:00) Brussels, Copenhagen, Madrid, Paris",
      code: "BRUSSELS"
    },
    {
      value: "2",
      text: "(GMT +2:00) Kaliningrad, South Africa",
      code: "KALINGRAD"
    },
    {
      value: "3",
      text: "(GMT +3:00) Baghdad, Riyadh, Moscow, St. Petersburg",
      code: "BAGHDAD"
    },
    {
      value: "3.5",
      text: "(GMT +3:30) Tehran",
      code: "TEHRAN"
    },
    {
      value: "4",
      text: "(GMT +4:00) Abu Dhabi, Muscat, Baku, Tbilisi",
      code: "ABU_DHABI"
    },
    {
      value: "4.5",
      text: "(GMT +4:30) Kabul",
      code: "KABUL"
    },
    {
      value: "5",
      text: "(GMT +5:00) Ekaterinburg, Islamabad, Karachi, Tashkent",
      code: "EKATERINBURG"
    },
    {
      value: "5.5",
      text: "(GMT +5:30) Bombay, Calcutta, Madras, New Delhi",
      code: "BOMBAY"
    },
    {
      value: "5.75",
      text: "(GMT +5:45) Kathmandu",
      code: "KATHMANDU"
    },
    {
      value: "6",
      text: "(GMT +6:00) Almaty, Dhaka, Colombo",
      code: "ALMATY"
    },
    {
      value: "7",
      text: "(GMT +7:00) Bangkok, Hanoi, Jakarta",
      code: "BANGKOK"
    },
    {
      value: "8",
      text: "(GMT +8:00) Beijing, Perth, Singapore, Hong Kong",
      code: "BEIJING"
    },
    {
      value: "9",
      text: "(GMT +9:00) Tokyo, Seoul, Osaka, Sapporo, Yakutsk",
      code: "TOKYO"
    },
    {
      value: "9.5",
      text: "(GMT +9:30) Adelaide, Darwin",
      code: "ADELAIDE"
    },
    {
      value: "10",
      text: "(GMT +10:00) Eastern Australia, Guam, Vladivostok",
      code: "EASTERN_AUS"
    },
    {
      value: "11",
      text: "(GMT +11:00) Magadan, Solomon Islands, New Caledonia",
      code: "MAGADAN"
    },
    {
      value: "12",
      text: "(GMT +12:00) Auckland, Wellington, Fiji, Kamchatka",
      code: "AUCKLAND"
    }
  ]
};
